module.exports = "/_next/static/images/harajuku_urahara_lunch-d0f4a15bd0c437e8474a578d1586da24.jpg";